// Broker configuration with SVG placeholder logos
// Replace with actual logo imports when you have the image files
// import growLogo from "../assets/images"
import growLogo from "../assets/images/growLogo.png"
import bigulLogo from  "../assets/images/bigulLogo.png";
import zerodhaLogo from "../assets/images/zerodhaLogo.png";
import upstoxLogo from "../assets/images/upstoxLogo.png";
import aliceLogo from "../assets/images/aliceLogo.png"

export const brokersList = [
  {
    id: 1,
    name: 'bigul',
    logo: bigulLogo,
    displayName: 'bigul',
    color: '#FF6B6B'
  },
  {
    id: 2,
    name: 'Groww',
    logo: growLogo,
    displayName: 'Groww',
    color: '#00D09C'
  },
  {
    id: 3,
    name: 'ZERODHA',
    logo: zerodhaLogo,
    displayName: 'ZERODHA',
    color: '#387ED1'
  },
  {
    id: 4,
    name: 'upstox',
    logo: upstoxLogo,
    displayName: 'upstox',
    color: '#6C3FD8'
  },
  {
    id: 5,
    name: 'aliceblue',
    logo: aliceLogo,
    displayName: 'aliceblue',
    color: '#4A90E2'
  }
];

/*
 * TO USE ACTUAL LOGO IMAGES:
 *
 * 1. Place your logo images in: src/pages/broker-integration/assets/logos/
 * 2. Import them at the top:
 *
 * import bigulLogo from '../assets/logos/bigul.png';
 * import growwLogo from '../assets/logos/groww.png';
 * import zerodhaLogo from '../assets/logos/zerodha.png';
 * import upstoxLogo from '../assets/logos/upstox.png';
 * import aliceblueLogo from '../assets/logos/aliceblue.png';
 *
 * 3. Update the logo property:
 *
 * export const brokersList = [
 *   {
 *     id: 1,
 *     name: 'bigul',
 *     logo: bigulLogo,
 *     displayName: 'bigul',
 *     color: '#FF6B6B'
 *   },
 *   // ... rest
 * ];
 */
